var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-upload",
    {
      staticStyle: { display: "inline-block" },
      attrs: {
        action: _vm.action,
        headers: { sessionId: _vm.sessionId },
        accept: _vm.accept,
        "show-file-list": false,
        "before-upload": _vm.handleBeforeUpload,
        "on-progress": _vm.handleProgress,
        "on-success": _vm.handleSuccess,
        "on-error": _vm.handleError,
        data: _vm.params,
        disabled: _vm.disabled
      }
    },
    [
      _c(
        "el-button",
        {
          attrs: { disabled: _vm.disabled, type: "primary" },
          on: { click: _vm.onClick }
        },
        [_vm._v(_vm._s(_vm.title))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }